import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import { createSelector } from 'reselect';

import { selectors as membershipSelectors } from '../memberships';
import { selectors as skillSelectors } from '../skills';
import { selectors as groupSelectors } from '../groups';
import { selectors as userSelectors } from '../users';

const options = {
  name: 'incidentResponses',
  baseType: 'INCIDENT_RESPONSES',
  apiEndpoint: 'incidents/{incident_id}/incident_responses'
};

const defaultSelectors = createMetadataAPISelectors(options);

// attendances with user and group objects
const augmentedAttendances = createSelector(
  defaultSelectors.values,
  userSelectors.byId,
  groupSelectors.byId,
  membershipSelectors.byId,
  skillSelectors.byId,
  (responses, usersById, groupsById, membershipsById, skillsById) =>
    responses
      .map(a => {
        let user = usersById[a.user_id];
        const group = groupsById[a.group_id];
        const membership = membershipsById[a.membership_id];
        user = {
          ...user,
          name: user ? `${user?.first_name} ${user?.last_name}` : null
        };
        const eligibleSkills = (membership?.skills || []).map(id => skillsById[id]).filter(Boolean);

        return { ...a, user, group, eligibleSkills };
      })
      .filter(Boolean)
);

export default {
  ...defaultSelectors,
  augmentedAttendances
};
